import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { border } from 'styled-system';
import { Box } from '@design-system/box';
import { useTheme } from '@design-system/theme';
import { FontAwesomeIcon } from './FontAwesomeIcon';
import { bgSizeToIconSize, colorToBgColor } from './utils';
export const FontAwesomeIconWithBackground = ({ color, height, ...otherProps }) => {
    const theme = useTheme();
    const iconSize = bgSizeToIconSize(height);
    const bgColor = colorToBgColor(color, theme);
    return (_jsx(BgBox, { alignItems: "center", bg: bgColor, borderRadius: "50%", justifyContent: "center", size: height, children: _jsx(FontAwesomeIcon, { color: color, height: iconSize, ...otherProps }) }));
};
const BgBox = styled(Box) `
  ${border}
`;
//# sourceMappingURL=FontAwesomeIconWithBackground.js.map